export const BitmapWriter = function() {

    var tmpCanvas;

    function writeInt(array, pos, intToWrite) {
        array[pos + 0] = intToWrite & 0xFF;
        array[pos + 1] = (intToWrite >> 8) & 0xFF;
        array[pos + 2] = (intToWrite >> 16) & 0xFF;
        array[pos + 3] = (intToWrite >> 24) & 0xFF;
    }

    function writeShort(array, pos, shortToWrite) {
        array[pos + 0] = shortToWrite & 0xFF;
        array[pos + 1] = (shortToWrite >> 8) & 0xFF;
    }

    this.writeBMP = function (inputImage, depth) {
        var width, height, headerSize, imageDataSize, bmpSize, rowSize, paddingSize;
        width = inputImage.width;
        height = inputImage.height;
        if (depth == 'undefined') depth = 32;
        headerSize = 54;
        rowSize = Math.floor((depth * width + 31) / 32) * 4;
        paddingSize = rowSize - (width * depth / 8);
        imageDataSize = (rowSize * height);
        bmpSize = headerSize + imageDataSize;
        var bmpFile = new Uint8Array(bmpSize);
        bmpFile[0] = 66; //'B';
        bmpFile[1] = 77; //'M';
        var pos = 2;
        writeInt(bmpFile, pos, bmpSize);
        pos += 4; // bitmap size
        writeShort(bmpFile, pos, 0);
        pos += 2; // reserved
        writeShort(bmpFile, pos, 0);
        pos += 2; // reserved
        writeInt(bmpFile, pos, headerSize);
        pos += 4; // offset of image data

        writeInt(bmpFile, pos, 40);
        pos += 4; // BITMAPINFOHEADER size
        writeInt(bmpFile, pos, width);
        pos += 4; // width
        writeInt(bmpFile, pos, height);
        pos += 4; // height
        writeShort(bmpFile, pos, 1);
        pos += 2; // color planes
        writeShort(bmpFile, pos, depth);
        pos += 2; // color depth
        writeInt(bmpFile, pos, 0);
        pos += 4; // compression 0 is none
        writeInt(bmpFile, pos, imageDataSize);
        pos += 4; // image size
        writeInt(bmpFile, pos, 0);
        pos += 4; // NOT USED: ppm width
        writeInt(bmpFile, pos, 0);
        pos += 4; // NOT USED: ppm height
        writeInt(bmpFile, pos, 0);
        pos += 4; // NOT USED: palette colors
        writeInt(bmpFile, pos, 0);
        pos += 4; // NOT USED: important colors
        var canvasContext = inputImage.getContext("2d");

        var imgData = canvasContext.getImageData(0, 0, width, height);
        var bmppos;
        for (var j = 0; j < height; j++) {
            for (var i = 0; i < width; i++) {
                bmppos = ((height - 1 - j) * width + i) << 2;

                bmpFile[pos++] = imgData.data[bmppos + 2];
                bmpFile[pos++] = imgData.data[bmppos + 1];
                bmpFile[pos++] = imgData.data[bmppos + 0];
                if (depth == 32) bmpFile[pos++] = imgData.data[bmppos + 3];
            }
            pos += paddingSize;
        }
        return bmpFile;
    };

    return this;
};
